__turbopack_context__.v({
  "badge": "badge-module__-HyWcG__badge",
  "error": "badge-module__-HyWcG__error",
  "info": "badge-module__-HyWcG__info",
  "md": "badge-module__-HyWcG__md",
  "neutral": "badge-module__-HyWcG__neutral",
  "sm": "badge-module__-HyWcG__sm",
  "success": "badge-module__-HyWcG__success",
  "warning": "badge-module__-HyWcG__warning",
});
